var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60548 2.47919C7.21748 1.39119 8.78308 1.39119 9.39428 2.47919L13.8583 10.4152C14.4583 11.4824 13.6879 12.7992 12.4647 12.7992H3.53588C2.31188 12.7992 1.54148 11.4824 2.14148 10.4152L6.60548 2.47919ZM8.79988 10.4C8.79988 10.6122 8.71559 10.8156 8.56556 10.9657C8.41553 11.1157 8.21205 11.2 7.99988 11.2C7.78771 11.2 7.58422 11.1157 7.43419 10.9657C7.28416 10.8156 7.19988 10.6122 7.19988 10.4C7.19988 10.1878 7.28416 9.98434 7.43419 9.83431C7.58422 9.68428 7.78771 9.59999 7.99988 9.59999C8.21205 9.59999 8.41553 9.68428 8.56556 9.83431C8.71559 9.98434 8.79988 10.1878 8.79988 10.4ZM7.99988 3.99999C7.78771 3.99999 7.58422 4.08428 7.43419 4.23431C7.28416 4.38434 7.19988 4.58782 7.19988 4.79999V7.19999C7.19988 7.41217 7.28416 7.61565 7.43419 7.76568C7.58422 7.91571 7.78771 7.99999 7.99988 7.99999C8.21205 7.99999 8.41553 7.91571 8.56556 7.76568C8.71559 7.61565 8.79988 7.41217 8.79988 7.19999V4.79999C8.79988 4.58782 8.71559 4.38434 8.56556 4.23431C8.41553 4.08428 8.21205 3.99999 7.99988 3.99999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/Exclamation.5b9d8155681d512d532b686cdbd6e13d.svg";
export { ForwardRef as ReactComponent };